<template>
    <div class="row dropdown-question">
        <div class="col-xl-3 col-xxl-2 question-label">{{label}}</div>
        <div class="col-xl-7 col-xxl-8 question">
            <select v-model="currentValue" class="form-select inner-select" :disabled="!allowChange">
                <option :value="null">{{placeholder}}</option>
                <option v-for="(val, index) in values" :value="val.value" :key="index">{{val.label}}</option>
            </select>
        </div>
        <div class="col-2 question-error">
          {{errors}}
        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LabelFilledMixin from './LabelFilledPlaceholdersComputedMixin'

export default {
  name: 'DropDown',
  props: ['question', 'modelValue', 'errors', 'default', 'allowChange'],
  mixins: [LabelFilledMixin],
  emits: ['update:modelValue'],
  data () {
    return {
    }
  },
  computed: {
    currentValue: {
      get () {
        return typeof this.modelValue !== 'undefined' ? this.modelValue : null
      },
      set (newValue) {
        this.$emit('update:modelValue', newValue)
      }
    },
    placeholder () {
      return this.question.placeholder
    },
    values () {
      var valueSet = []
      valueSet = this.default && this.question.dependsOn ? this.question.values.filter((v) => v.value !== this.default) : this.question.values
      return valueSet.sort((v1, v2) => {
        if (/^\d+(?:\.\d+)?$/.test(v1.label)) {
          var number1 = parseFloat(v1.label)
          var number2 = parseFloat(v2.label)
          return this.question.reverseSort ? number2 - number1 : number1 - number2
        } else {
          var label1 = v1.label.toUpperCase()
          var label2 = v2.label.toUpperCase()
          return this.question.reverseSort
            ? label1 < label2 ? 1 : label1 > label2 ? -1 : 0
            : label1 < label2 ? -1 : label1 > label2 ? 1 : 0
        }
      })
    },
    ...mapGetters({
      leadInfo: 'consumer/lead/leadInfo'
    })
  },
  mounted () {
  },
  watch: {
  }
}
</script>

<style scoped>
.form-select.inner-select {
  width: auto;
}
</style>
